import { Modal, Typography } from '@crisellevaldez/speculo-ui';
import { Mail, Calendar } from 'lucide-react';
import { IconPill } from '../../common/IconPill';
import { useSupportContact } from '../../../hooks/useSupportContact';
import type { SupportContact } from '../../../constants/supportContact';

interface ScheduleCallModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Pins the contact (email and calendar), ignoring the org's support-contact setting. */
  supportContact?: SupportContact;
}

export function ScheduleCallModal({ isOpen, onClose, supportContact }: ScheduleCallModalProps) {
  const orgSupportContact = useSupportContact();
  const contact = supportContact ?? orgSupportContact;
  const meetingUrl = `${contact.bookingUrl}?embed=true`;
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <Modal.Header>
        <div className="text-center">
          <Typography variant="h3">Have Questions?</Typography>
          <p className="text-sm text-muted-foreground font-medium">
            Email us or schedule a call with {contact.name}
          </p>
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* Contact Options */}
        <div className="mb-4 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
          <div className="flex items-center gap-3">
            <IconPill icon={Mail} size="lg" />
            <div>
              <p className="text-sm font-medium text-foreground">Email Us</p>
              <a
                href={`mailto:${contact.email}`}
                className="text-sm text-amber-700 hover:text-amber-800 dark:text-amber-400 dark:hover:text-amber-300 hover:underline transition-colors"
              >
                {contact.email}
              </a>
            </div>
          </div>

          <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
            Or
          </span>

          <div className="flex items-center gap-3">
            <IconPill icon={Calendar} size="lg" />
            <div>
              <p className="text-sm font-medium text-foreground">Schedule a Call</p>
              <p className="text-sm text-muted-foreground">Pick a time below</p>
            </div>
          </div>
        </div>

        {/* HubSpot Meetings Embed */}
        <iframe
          src={meetingUrl}
          title={`Schedule a call with ${contact.name}`}
          width="100%"
          height="700"
          frameBorder="0"
          className="w-full"
        />
      </Modal.Body>
    </Modal>
  );
}
